import React from 'react';
import { Icon, Tooltip } from 'antd';
import { useNavigate } from "react-router-dom";


type Props = {
    urlGuid: string;
    websiteGuid: string;
    url: string;
    isAnalyzed: boolean;
    seoTestKey?: string;
    statusCode: number;
};


export default function ServiceableUrlsLinkCell({ urlGuid, websiteGuid, url, isAnalyzed, seoTestKey, statusCode }: Props) {
    const navigate = useNavigate();

    const handleUrlClick = () => {
        const fragment = seoTestKey ? `#${seoTestKey}` : '';
        const newSearchString = `?w_guid=${websiteGuid}&url_guid=${urlGuid}${fragment}`;

        if (isAnalyzed) {
            navigate(`/deep-analysis/report${newSearchString}`);
        }
    };

    return (
        <>
            {isAnalyzed && statusCode === 200 && (
                <div className="url-cell-with-view-report">
                    <div className="action-button-column truncate">
                        <span className="link" onClick={handleUrlClick}>{url}</span>
                    </div>
                    <div className="view-report-link">view report</div>
                </div>
            )}

            {isAnalyzed && statusCode >= 400 && (
                <>
                    <div className="action-button-column truncate" style={{ maxWidth: "640px", display: "inline-block" }} title={url}>
                        <span style={{ color: "#969696" }}>{url}</span>
                    </div>
                    <Tooltip title={`Status code: ${statusCode}`}>
                        <span style={{ color: "#ff0000", marginLeft: "6px", fontSize: "14px", verticalAlign: "top" }}><Icon type="warning" /></span>
                    </Tooltip>
                </>
            )}

            {!isAnalyzed && (
                <div className="action-button-column truncate" style={{ maxWidth: "640px" }}>
                    <span>{url}</span>
                </div>
            )}
        </>
    )
}
